/**
 * Decides what to do with a history item whose final answer was never saved.
 * The browser saves that copy when a debate finishes, so leaving early skips it
 * even though the backend carries on and finishes the debate.
 */

/** startDebate's timeoutSeconds plus a margin. A debate still "running" after this has died. */
const MAX_DEBATE_RUNTIME_MS = 65 * 60_000;

export type DebateResumeState = "live" | "finished" | "failed";

export function debateResumeState(
  debate: {
    status?: string;
    facilitatorDone?: boolean;
    finalAggregate?: string | null;
    createdAt?: { toMillis?: () => number } | null;
  },
  now: number,
): DebateResumeState {
  if (debate.facilitatorDone === true && debate.finalAggregate) return "finished";
  if (debate.status !== "running") return "failed";
  const startedAt = debate.createdAt?.toMillis?.();
  return startedAt !== undefined && now - startedAt > MAX_DEBATE_RUNTIME_MS ? "failed" : "live";
}

/** Everyone who speaks in a finished audio debate, as the audio view tracks them. */
export function finishedAudioTurns(experts: string[]): string[] {
  return [
    ...experts.flatMap((expert) =>
      ["initial", "feedback", "revision"].map((phase) => `${expert}-${phase}`),
    ),
    "chaos-chaos",
    "facilitator-final",
  ];
}
